/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { MultiSelect } from "primereact/multiselect"
import { ListBox } from "primereact/listbox"
import {
  enrolledEducationTypes,
  educationLevelTypes,
  employedTypes,
  haveEnoughMoneyTypes,
  annualIncome,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Education = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    activeIndex,
    sections,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [education, setEducation] = useState(
    interview[INTERVIEW_SECTIONS.EDUCATION]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.EDUCATION &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.EDUCATION
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.EDUCATION, education)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_EDUCATION_DATA, {
          GpraD1: education?.gpra_d_1,
          GpraD2: education?.gpra_d_2,
          GpraD2a: education?.gpra_d_2a,
          GpraD3: education?.gpra_d_3,
          GpraD3a: education?.gpra_d_3a,
          GpraD4a: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[0].value
          ),
          GpraD4b: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[1].value
          ),
          GpraD4c: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[2].value
          ),
          GpraD4d: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[3].value
          ),
          GpraD4e: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[4].value
          ),
          GpraD4f: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[5].value
          ),
          GpraD4g: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[6].value
          ),
          GpraD4h: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[7].value
          ),
          GpraD4i: education?.gpra_d_4?.find(
            (i) => i === haveEnoughMoneyTypes[8].value
          ),
          GpraD5: education?.gpra_d_5,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraDId: education?.gpra_d_id,
          Additional: getAdditionalQuestions(education),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.EDUCATION, {
                ...education,
                gpra_d_id: response.data.gpraDId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ education: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.toastErrorDetail, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const validForm = () => {
    const errors = {}
    if (!education?.gpra_d_1 && showQuestion(questions, "gpra_d_1")) {
      errors.gpra_d_1 = errorMessages.requiredMessage
    }
    if (!education?.gpra_d_2 && showQuestion(questions, "gpra_d_2")) {
      errors.gpra_d_2 = errorMessages.requiredMessage
    } else if (education?.gpra_d_2 === "Other") {
      if (!education?.gpra_d_2a) {
        errors.gpra_d_2a = errorMessages.requiredMessage
      }
    }
    if (!education?.gpra_d_3 && showQuestion(questions, "gpra_d_3")) {
      errors.gpra_d_3 = errorMessages.requiredMessage
    } else if (education?.gpra_d_3 === "Other") {
      if (!education?.gpra_d_3a) {
        errors.gpra_d_3a = errorMessages.requiredMessage
      }
    }
    if (
      education?.gpra_d_4.length === 0 &&
      showQuestion(questions, "gpra_d_4")
    ) {
      errors.gpra_d_4 = errorMessages.enoughMoneyExpenses
    }
    if (!education?.gpra_d_5 && showQuestion(questions, "gpra_d_5")) {
      errors.gpra_d_5 = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        education,
        INTERVIEW_SECTIONS.EDUCATION,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_d_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Are you currently enrolled in school or a job training program? [IF ENROLLED] is that full time or part time?`}
            required
          />
          <Dropdown
            className={
              validationErrors.gpra_d_1
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
            value={education?.gpra_d_1}
            onChange={(e) => {
              updateState(
                "gpra_d_1",
                e.value,
                null,
                null,
                education,
                setEducation,
                null
              )
              removeError("gpra_d_1")
            }}
            options={enrolledEducationTypes}
            optionLabel="label"
            optionValue="value"
            showClear={education?.gpra_d_1}
            disabled={disabled}
          />
          <FormError error={validationErrors.gpra_d_1} />
        </div>
      )
    }
    if (question.field === "gpra_d_2") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. What is the highest level of education you have finished, whether or not you received a degree?`}
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_d_2
                  ? gpraStyles.input6Error
                  : gpraStyles.input6
              }
              value={education?.gpra_d_2}
              onChange={(e) => {
                updateState(
                  "gpra_d_2",
                  e.value,
                  null,
                  null,
                  education,
                  setEducation,
                  [{ key: "gpra_d_2a", value: "" }]
                )
                removeError("gpra_d_2")
                removeError("gpra_d_2a")
              }}
              options={educationLevelTypes}
              optionLabel="label"
              optionValue="value"
              showClear={education?.gpra_d_2}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_d_2} errorType={2} />
          </div>
          {education?.gpra_d_2 === "Other" && (
            <div className={gpraStyles.formRow}>
              <FormLabel label={"Other (Specify)"} />
              <InputText
                disabled={education?.gpra_d_2 !== "Other" || disabled}
                placeholder={
                  education?.gpra_d_2 !== "Other" && "Not Applicable"
                }
                value={education?.gpra_d_2a}
                onChange={(e) => {
                  updateState(
                    "gpra_d_2a",
                    e.target.value,
                    null,
                    null,
                    education,
                    setEducation,
                    null
                  )
                  removeError("gpra_d_2a")
                }}
                className={
                  validationErrors.gpra_d_2a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
              />
              <FormError error={validationErrors.gpra_d_2a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_d_3") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Are you currently employed? [CLARIFY BY FOCUSING ON STATUS DURING MOST OF THE PREVIOUS WEEK, DETERMINING WHETHER CLIENT WORKED AT ALL OR HAD A REGULAR JOB BUT WAS OFF WORK.] [IF CLIENT IS INCARCERATED AND HAS NO WORK OUTSIDE OF JAIL, CODE D3 AS “NOT LOOKING FOR WORK.”]`}
              required            
            />
            <Dropdown
              className={
                validationErrors.gpra_d_3
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={education?.gpra_d_3}
              onChange={(e) => {
                updateState(
                  "gpra_d_3",
                  e.value,
                  null,
                  null,
                  education,
                  setEducation,
                  null
                )
                removeError("gpra_d_3")
                removeError("gpra_d_3a")
              }}
              options={employedTypes}
              optionLabel="label"
              optionValue="value"
              showClear={education?.gpra_d_3}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_d_3} errorType={2} />
          </div>
          {education?.gpra_d_3 === "Other" && (
            <div className={gpraStyles.formRow}>
              <FormLabel label={"Other (Specify)"} left={"1"} required/>
              <InputText
                disabled={education?.gpra_d_3 !== "Other" || disabled}
                placeholder={
                  education?.gpra_d_3 !== "Other" && "Not Applicable"
                }
                value={education?.gpra_d_3a}
                onChange={(e) => {
                  updateState(
                    "gpra_d_3a",
                    e.target.value,
                    null,
                    null,
                    education,
                    setEducation,
                    null
                  )
                  removeError("gpra_d_3a")
                }}
                className={
                  validationErrors.gpra_d_3a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
              />
              <FormError error={validationErrors.gpra_d_3a} errorType={2} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_d_4") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Do you, individually, have enough money to pay for the following living expenses? Choose all that apply.`}
            required
          />
          {disabled ? (
            <ListBox
              disabled
              options={education?.gpra_d_4}
              className={gpraStyles.input4}
            />
          ) : (
            <MultiSelect
              value={education?.gpra_d_4}
              maxSelectedLabels={4}
              options={haveEnoughMoneyTypes}
              onChange={(e) => {
                if (e.value?.find((i) => i === "Refused")) {
                  updateState(
                    "gpra_d_4",
                    ["Refused"],
                    null,
                    null,
                    education,
                    setEducation,
                    null
                  )
                } else {
                  updateState(
                    "gpra_d_4",
                    e.value,
                    null,
                    null,
                    education,
                    setEducation,
                    null
                  )
                }
                removeError("gpra_d_4")
              }}
              optionLabel="label"
              optionValue="value"
              showSelectAll={false}
              showClear={education?.gpra_d_4}
              disabled={disabled}
              className={
                validationErrors.gpra_d_4
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
            />
          )}

          <FormError error={validationErrors.gpra_d_4} />
        </div>
      )
    }
    if (question.field === "gpra_d_5") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. What is your personal annual income, meaning the total pre-tax income from all sources, earned in the past year?`}
            required
          />
          <Dropdown
            disabled={disabled}
            value={education?.gpra_d_5}
            onChange={(e) => {
              updateState(
                "gpra_d_5",
                e.value,
                null,
                null,
                education,
                setEducation,
                null
              )
              removeError("gpra_d_5")
            }}
            options={annualIncome}
            optionLabel="label"
            optionValue="value"
            showClear={education?.gpra_d_5}
            className={
              validationErrors.gpra_d_5
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_d_5} errorType={2} />
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="D. EDUCATION, EMPLOYMENT, AND INCOME"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={education}
                    setEntity={setEducation}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.EDUCATION}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, education)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={education}
                      setEntity={setEducation}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.EDUCATION}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </div>
  )
}

Education.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Education.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Education
